import styled from '../../../../styles/styledComponents/themeComponents';

export const HomeTabListHeaderStyle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > h2 {
    font-size: 16px;
    font-weight: 600;
    color: #495057;
  }
`;
